
import React from 'react';
import { Link } from 'react-router-dom';
const Newsletter = () => {
  return (
    // <div className="bg-[#90C03E] text-white p-5  flex flex-col md:flex-row items-center justify-between rounded-lg shadow-md">
    //   <div className="flex-1 mb-4 md:mb-0 p-10 ">
    //     <h2 className="text-2xl font-bold mb-2 ">Join Us on Our Mission</h2>
    //     <p className="text-lg text-justify">Experience the difference that Ultrapure's air purification solutions can make in your indoor environment. Together, let's create a healthier and cleaner world for future generations.</p>
    //   </div>
    //   <div className="m-4 lg:w-2/5  text-end">
    //     <Link to="/contact" className="bg-white text-[#90C03E] font-bold py-2 px-10 rounded hover:bg-gray-200  ">
    //       Contact Us  <span aria-hidden="true">&rarr;</span>
    //     </Link>
    //   </div>
    // </div>

    <section className="bg-gray-50 py-2 lg:py-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row min-h-[300px]">

          {/* Right Section - Need Assistance (First on mobile, Right on desktop) */}
          <div className="w-full lg:w-1/2 flex items-center justify-center p-2 lg:p-6 order-1 lg:order-2">
            <div className="max-w-lg text-center lg:text-left">

              {/* Title */}
              <h2 className="text-3xl lg:text-4xl font-normal text-gray-800 mb-3 lg:mb-4">
                Need Assistance?
              </h2>

              {/* Description */}
              <p className="text-gray-500  leading-relaxed mb-3 lg:mb-5 font-thin text-[14px]">
                Whether you're exploring clean air solutions or need support for an existing installation, our team is here to help. Let's create a healthier environment—together.
              </p>

              {/* Support Button */}
              <Link to="/contact">
                <button className="bg-[#1C97D4] hover:bg-blue-600 text-white font-semibold px-10 py-3 rounded-lg text-base lg:text-lg transition-all duration-300 transform hover:scale-105 hover:shadow-xl shadow-lg">
                  SUPPORT
                </button>
              </Link>
            </div>
          </div>

          {/* Left Section - Contact Info (Second on mobile, Left on desktop) */}
          <div className="w-full lg:w-1/2 flex items-center justify-center p-4 lg:p-6 order-2 lg:order-1">
            <div className="flex flex-col space-y-6 text-center lg:text-left w-full max-w-md">

              {/* Phone */}
              <div className="flex items-center justify-center lg:justify-start space-x-3">
                <img src="./phone-call 1.svg" width={25} alt="Phone Icon" />
                <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-2">
                  <a
                    href="tel:1800110050"
                    className="text-base sm:text-xl lg:text-2xl text-gray-800 font-medium hover:underline"
                  >
                    1800-1100-50
                  </a>
                  <span className="text-gray-500 text-sm sm:text-base lg:text-lg">(Toll Free)</span>
                </div>
              </div>

              {/* Email */}
              <div className="flex items-center justify-center lg:justify-start space-x-3">
                <img src="./mail 1.svg" width={25} alt="Mail Icon" />
                <a
                  href="mailto:info@ultrapureindia.in"
                  className="text-base sm:text-xl lg:text-2xl text-gray-800 font-medium break-words hover:underline"
                >
                  info@ultrapureindia.in
                </a>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Newsletter;
